{
  "app": {
    "name": "ATNT Konstruktor",
    "loading": "Yuklanmoqda…"
  },
  "auth": {
    "title": "Tizimga kirish",
    "subtitle": "Suv omborlari monitoringi platformasi",
    "login": "Login",
    "loginPlaceholder": "Loginni kiriting",
    "password": "Parol",
    "passwordPlaceholder": "Parolni kiriting",
    "submit": "Kirish",
    "logout": "Chiqish",
    "showPassword": "Parolni ko'rsatish",
    "hidePassword": "Parolni yashirish"
  },
  "common": {
    "save": "Saqlash",
    "cancel": "Bekor qilish",
    "back": "Ortga qaytish",
    "delete": "O'chirish",
    "edit": "Tahrirlash",
    "add": "Qo'shish",
    "search": "Qidirish",
    "preview": "Ko'rish",
    "close": "Yopish",
    "retry": "Qayta urinish",
    "home": "Bosh sahifa"
  },
  "errors": {
    "generic": "Xatolik yuz berdi",
    "notFound": "Sahifa topilmadi",
    "notFoundHint": "Siz qidirayotgan sahifa mavjud emas yoki unga kirish huquqingiz yo'q."
  }
}
